// @Vendors
import React, { Component } from 'react';

// @Components
import StaticImg from './StaticImg';

class HooliLogo extends Component {
	render() {
		const { claim } = this.props;
		return (
			<div id='logo_hooli'>
				<StaticImg src='logos/logo_hooli.svg' alt='Hooli' />
				{claim && <div className='claim'>{claim}</div>}
			</div>
		);
	}
}

export default HooliLogo;



// WEBPACK FOOTER //
// ./src/components/HooliLogo.js